export default "__VITE_ASSET__DvchO7V3__"